import React from 'react';
import { StatusPill } from 'Components/StatusPill/StatusPill.styled';
import { EmptyText } from '../../../Dashboard.styled';
import { Grid, Tile, TileTitle } from './ApprovedCoursesGrid.styled';
import type { ApprovedRowVM } from '../../../hooks/useDashboardPage';

export interface ApprovedCoursesGridProps {
  rows: ApprovedRowVM[];
  emptyText: string;
  onTileClick: (id: string) => void;
}

export default function ApprovedCoursesGrid({ rows, emptyText, onTileClick }: ApprovedCoursesGridProps) {
  if (rows.length === 0) return <EmptyText>{emptyText}</EmptyText>;

  return (
    <Grid>
      {rows.map(row => (
        <Tile key={row.id} type="button" onClick={() => onTileClick(row.id)}>
          <TileTitle>{row.name}</TileTitle>
          <StatusPill small variant={row.statusVariant}>
            {row.statusLabel}
          </StatusPill>
        </Tile>
      ))}
    </Grid>
  );
}
